import { render } from "./TabArea.vue?vue&type=template&id=24703b62"
import script from "./TabArea.vue?vue&type=script&lang=js"
export * from "./TabArea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__